import AbstractRestClient from '../AbstractRestClient';
import store from '../../redux/store';

class CommentsRestClient extends AbstractRestClient {
  getUser = () => store.getState().auth.user.id;

  fetchProductComments(product, offset = 0, pageSize = 3) {
    return this.instance.get(
      `/api/es_ar/products/${product}/comments?offset=${offset}&pageSize=${pageSize}`
    );
  }

  postParentComment(product, comment) {
    return this.instance.post(`/api/es_ar/products/${product}/comments`, {
      comment
    });
  }

  fetchSellerComments(filter = 'all', offset = 0, pageSize = 10) {
    const user = this.getUser();
    return this.instance.get(
      `/api/es_ar/users/${user}/seller/comments?filter=${filter}&offset=${offset}&pageSize=${pageSize}`
    );
  }

  fetchBuyerComments(filter = 'all', offset = 0, pageSize = 10) {
    const user = this.getUser();
    return this.instance.get(
      `/api/es_ar/users/${user}/buyer/comments?filter=${filter}&offset=${offset}&pageSize=${pageSize}`
    );
  }

  fetchComment(comment) {
    return this.instance.get(`/api/es_ar/comments/${comment}`);
  }

  createChildComment(parentComment, comment) {
    return this.instance.post(`/api/es_ar/comments/${parentComment}/comments`, {
      comment
    });
  }

  markCommentAsSeen(parentComment) {
    return this.instance.post(`/api/es_ar/comments/${parentComment}/seens`);
  }
}

export default new CommentsRestClient();
